import React, { useState } from 'react';

const BulkUpdateModal = ({ onClose, onSubmit }) => {
  const [fieldName, setFieldName] = useState('');
  const [oldValue, setOldValue] = useState('');
  const [newValue, setNewValue] = useState('');

  // Only user-editable fields
  const availableFields = [
    { value: 'full_name', label: 'Full Name' },
    { value: 'mother_name', label: 'Mother Name' },
    { value: 'place_of_birth', label: 'Place of Birth' },
    { value: 'phone', label: 'Phone Number' },
    { value: 'organization', label: 'Organization' },
    { value: 'title', label: 'Title' },
    { value: 'bank_account', label: 'Bank Account' },
    { value: 'salary_usd', label: 'Salary (USD)' },
    { value: 'allowance_usd', label: 'Allowance' },
    { value: 'address', label: 'Address' },
    { value: 'training', label: 'Training' },
    { value: 'army_equipment', label: 'Army Equipment' },
    { value: 'remarks', label: 'Remarks' },
    { value: 'work_place', label: 'Work Place' },
    { value: 'station', label: 'Station' },
  ];

  const handleSubmit = () => {
    if (!fieldName || !oldValue || !newValue) {
      alert('Please fill all fields');
      return;
    }
    onSubmit({ fieldName, oldValue, newValue });
  };

  return (
    <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Bulk Update Personnel</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <div className="formInpt mb_16">
              <label className="mb_10">Select Field to Update</label>
              <select
                className="customSelect"
                value={fieldName}
                onChange={(e) => setFieldName(e.target.value)}
              >
                <option value="">-- Select Field --</option>
                {availableFields.map(field => (
                  <option key={field.value} value={field.value}>
                    {field.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="formInpt mb_16">
              <label className="mb_10">Old Value (to match)</label>
              <input
                type="text"
                placeholder="Enter current value to match"
                value={oldValue}
                onChange={(e) => setOldValue(e.target.value)}
              />
              <small style={{ color: '#6c757d', display: 'block', marginTop: '4px' }}>
                Only records with this exact value will be updated
              </small>
            </div>
            <div className="formInpt mb_16">
              <label className="mb_10">New Value</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter new value"
                value={newValue}
                onChange={(e) => setNewValue(e.target.value)}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={onClose}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleSubmit}>
              Update Records
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkUpdateModal;
